const queryParameters = {
  WORKSPACE_ID: 'workspaceId',
  TEMPLATE_KEY: 'templateKey',
  NEW_USER_ONBOARDING_FLOW: 'newUserOnboardingFlow',
  USERNAME: 'userName',
  ALLOW_GUEST_MODAL: 'allowGuestModal',
  ACCESS_CODE: 'accessCode',
  SCENE_ID: 'sceneId',
  INTENT: 'intent',
  EMAIL_ADDRESS: 'emailAddress',
  RETRY_WRITES: 'retryWrites',
  REGISTRATION_CODE: 'registrationCode',
  REDIRECT_URI: 'redirect_uri',
  USER_ID: 'userId',
  USER_SCOPE: 'user_scope',
  UPDATED_AT: 'updatedAt',
  PREVIEW: 'preview',
  LEFT_MEETING: 'leftMeeting',
  CLIENT_ID: 'client_id',
  CLIENT_SECRET: 'client_secret',
  MEETING_SERIES_ID: 'meetingSeriesId',
  PRESENTATION_ID: 'presentationId',
  PASSWORD_RESET_CODE: 'passwordResetCode',
  JOINING_USER_DATA: 'q',
};

const convertJSONToBase64 = (data) => {
  const b64string = Buffer.from(JSON.stringify(data)).toString('base64');
  return b64string
    .replaceAll('+', '.')
    .replaceAll('/', '_')
    .replaceAll('=', '-');
};

const convertBase64ToJSON = (MyBuffer, base64string) => {
  if (!base64string) return null;
  const str = base64string
    .replace(/\./g, '+')
    .replace(/_/g, '/')
    .replace(/-/g, '=');
  const jsonStr = MyBuffer.from(str, 'base64').toString('utf8');
  try {
    return JSON.parse(jsonStr);
  } catch (err) {
    console.log(
      'Invalid JSON attempting to decode from a base64 string',
      jsonStr
    );
  }
  return null;
};

// Used for query params that contain emojis
const convertBase64ToJSONv2 = (base64string) => {
  if (!base64string) return null;
  const jsonStr = decodeURIComponent(escape(window.atob(base64string)));
  try {
    return JSON.parse(jsonStr);
  } catch (err) {
    console.log(
      'Invalid JSON attempting to decode from a base64 string',
      jsonStr
    );
  }
  return null;
};

module.exports = {
  queryParameters,
  convertBase64ToJSON,
  convertJSONToBase64,
  convertBase64ToJSONv2,
};
